import React from 'react';

import ChurnedUserReactivationButton from './ChurnedUserReactivationButton';
import PremiumText from './PremiumText';
import PremiumButton from './PremiumButton';
import { PremiumUpsells } from './types';

type Props = {
  premiumUpsells?: PremiumUpsells;
  isMobileNav: boolean;
};

const PremiumUpsellButton = ({ premiumUpsells, isMobileNav }: Props) => {
  if (premiumUpsells?.churnedUserReactivationDiscount) {
    return (
      <ChurnedUserReactivationButton
        discount={premiumUpsells?.churnedUserReactivationDiscount}
        isMobileNav={isMobileNav}
      />
    );
  }

  if (isMobileNav) {
    return (
      <PremiumText
        coupon={premiumUpsells?.halfOffCoupon}
        reactivate={premiumUpsells?.reactivatePremiumUpsellType}
        newUserDiscount={premiumUpsells?.newUserDiscount}
        trialPricingCopy={premiumUpsells?.trialPricingCopy}
      />
    );
  } else {
    return (
      <PremiumButton
        coupon={premiumUpsells?.halfOffCoupon}
        reactivate={premiumUpsells?.reactivatePremiumUpsellType}
        newUserDiscount={premiumUpsells?.newUserDiscount}
        trialPricingCopy={premiumUpsells?.trialPricingCopy}
      />
    );
  }
};

export default PremiumUpsellButton;
